import {
  TagOutlined,
  ShoppingCartOutlined,
  HeartOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons";

export const getSideBarData = (admin) => {
  return [
    {
      id: "0",
      path: "/dashboard",
      name: "Dashboard",
      icon: <TagOutlined />,
    },
    {
      id: "1",
      path: "/users",
      name: "Users",
      icon: <UserOutlined />,
    },
    {
      id: "2",
      path: "/franchaise",
      name: "Franchaise",
      icon: <FileTextOutlined />,
    },
    {
      id: "3",
      path: "/dealersip",
      name: "Dealership",
      icon: <HeartOutlined />,
    },
    {
      id: "4",
      path: "/sellyourbusiness",
      name: "Sell your business",
      icon: <ShoppingCartOutlined />,
    },
    {
      id: "5",
      path: "/investor",
      name: "Investor",
      icon: <TagOutlined />,
    },
    {
      id: "6",
      path: "/plans",
      name: "Plans",
      icon: <FileTextOutlined />,
    },
      {
      id: "7",
      path: "/happy-customers",
      name: "Add Happy Customers",
      icon: <FileTextOutlined />,
    },
    {
      id: "8",
      path: "/contact",
      name: "Contact",
      icon: <TagOutlined />,
    },
  ];
};
